module.exports = __webpack_public_path__ + "img/Logout.b218b0ac.svg";